import React, { useMemo } from "react";
import Carousel from "react-bootstrap/Carousel";
import { useHistory } from "../../../../app-services/lib/router-compat";
import useBanners, { pageBanners } from "../../../../app-services/hooks/useBanners";
import "./banner.css";

const Banner = (productpage) => {
  const history = useHistory();
  const bannerlist = useBanners();
  const currentData = useMemo(
    () =>
      pageBanners(
        bannerlist,
        productpage.productpage == true ? "product" : "home",
      ),
    [bannerlist, productpage.productpage],
  );
  //console.log("productpage", currentData.length);
  return (
    <>
      <div
        className={
          "bannerContainer " +
          (productpage.productpage == true ? "" : "homebanner") +
          (currentData.length == 1 ? "hideindicator" : "")
        }
      >
        <Carousel interval={1500} variant="dark">
          {currentData.map((value, index) => (
            <Carousel.Item key={index}>
              <img
                className="BannerIMage"
                src={value.file.filePath}
                alt={value.file.fileName}
              />
              {value.title && (
                <Carousel.Caption>
                  <h3>{value.title}</h3>
                  <p>{value.subtitle}</p>
                </Carousel.Caption>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default Banner;
